import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { LoginContext } from '../Contexts/LoginContext';
import SellerLayout from '../Layouts/SellerLayout';
import { showToast } from "../Components/utils/ShowToast";
import SEO from '../Components/utils/SEO';

const ProtectedRoute = ({ children, isDestinationTradelead, isFooter=true }) => {
    const { isLogin, user } = useContext(LoginContext);

    if (isLogin === null)
        return null;

    if (!isLogin) {
        showToast("Please login to access that Resource!", "info")
        return <Navigate to="/signin" replace />;
    }

    else if (!(user?.role === "seller")) {
        showToast("You are not a Seller. Please create seller account to access that Resource!", "info")
        return <Navigate to="/becomeSeller" replace />
    }

    else if (isDestinationTradelead && user?.sellerId?.planType === "Free") {
        showToast("Only paid sellers can access Tradeleads! Upgrade your Account", "info")
        return <Navigate to="/upgrade" replace />
    }

    return (
        <>
            <SEO title="Seller account" description="Chocowi seller dashboard" noIndex noFollow />
            <SellerLayout isFooter={isFooter}>{children}</SellerLayout>
        </>
    );
};

export default ProtectedRoute;